import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MPageBannerComponent } from './page-banner.component';

@NgModule({
  declarations: [MPageBannerComponent],
  exports: [MPageBannerComponent],
  imports: [CommonModule, FormsModule, NzIconModule]
})
export class MPageBannerModule {}
